/**
 * Vault Utilities - v4.0
 *
 * Helper functions for vault and tier display/formatting
 */

/**
 * Map tier names to display names
 * Handles both legacy enum values and new tier names
 */
export const getTierDisplayName = (tier: string): string => {
  if (tier === 'ELITE') return 'TREASURY';
  return tier;
};

/**
 * Get CSS class for tier badge based on tier name/number
 * Supports both legacy (STARTER/PRO/ELITE) and new dynamic tier names
 */
export const getTierBadgeClass = (tierName: string): string => {
  const name = tierName.toUpperCase();
  if (name.includes('ELITE') || name.includes('TREASURY') || name === 'TIER 1') {
    return 'tier-elite';
  }
  if (name.includes('PRO') || name === 'TIER 2') {
    return 'tier-pro';
  }
  // Default for STARTER, BASIC, and any new tiers
  return 'tier-starter';
};
